import {useEffect} from "react";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";

const CftvMapFitBounds = ({center, cameras, radiusMeters}) => {
    const map = useMap();
    const coreLib = useMapsLibrary("core");
    const geometryLib = useMapsLibrary("geometry");

    useEffect(() => {
        if (!map || !coreLib || !geometryLib) return;

        const bounds = new coreLib.LatLngBounds();
        const origin = new coreLib.LatLng(center.lat, center.lng);
        [0, 90, 180, 270].forEach(heading => {
            bounds.extend(geometryLib.spherical.computeOffset(origin, radiusMeters, heading));
        });

        cameras.forEach(camera => {
            const lat = Number(camera.lat ?? camera.latitude);
            const lng = Number(camera.lng ?? camera.longitude);

            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                bounds.extend({lat, lng});
            }
        });
        map.fitBounds(bounds, 30);
    }, [map, coreLib, geometryLib, center.lat, center.lng, cameras, radiusMeters]);

    return null;
};

export default CftvMapFitBounds;
